import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DsLink } from '../DsLink';
export default class ExpandCollapsedIcon extends React.Component {
    render() {
        return _jsx(DsLink, { children: "..." });
    }
}
